
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_5a145_8b4wa_9",
  "inline-container": "awsui_inline-container_5a145_8b4wa_13",
  "inline-container-trigger": "awsui_inline-container-trigger_5a145_8b4wa_16",
  "inline-container-no-wrap": "awsui_inline-container-no-wrap_5a145_8b4wa_19",
  "text-to-display": "awsui_text-to-display_5a145_8b4wa_28"
};
  